import moment from 'moment';
import { memo } from 'react';
import Calendar, { CalendarProps } from 'react-calendar';
import './calendar.css';

type MyCalendarPropsType = CalendarProps;

const MyCalendar = ({ minDate, maxDate, ...props }: MyCalendarPropsType) => {
    return <Calendar calendarType='gregory' locale='ko' minDate={minDate} maxDate={maxDate}
        formatDay={(locale, date) => moment(date).format('DD')}
        {...props}
    />
}

export default memo(MyCalendar);